/* eslint-disable */
import type { Money } from "../common/currency.pb";
import type { Orientation } from "./orientation.pb";

export enum PaymentScheduleState {
  /** ACTIVE - The payment schedule has at least one future payment to send. */
  ACTIVE = "ACTIVE",
  /** PAUSED - Similar to ACTIVE, but the payment will be skipped when it is time to send. */
  PAUSED = "PAUSED",
  /** COMPLETED - All scheduled payments were sent. This is a terminal state. */
  COMPLETED = "COMPLETED",
  /** CANCELLED - Either manually cancelled by customer or met a failure criteria. This is a terminal State. */
  CANCELLED = "CANCELLED",
}

/**
 * Represents a schedule that conforms to the parameters specified in the RFC2445 specification.
 *  Currently this only specifies parts of RRULE (recurrence rule).
 */
export interface ScheduleRFC2445 {
  /**
   * Represents the scheduled datetime (UTC) for a one-time schedule,
   *  or the (optional) inclusive start date of the recurring schedule.
   */
  start_date?: number;
  /** The timezone ID (using tz database standard) this schedule should operate in. */
  timezone?: string;
  frequency?: ScheduleRFC2445Frequency;
  /**
   * The interval to operate the frequency on.
   *  Ex. Frequency=WEEKLY, and interval = 2 means every 2 weeks.
   */
  interval?: number;
  by_day?: ScheduleRFC2445ByDay[];
  /**
   * The day of the month (from -31 to 31) this schedule applies to.
   *  NOTE: If the month does not not contain the day, it is skipped.
   *  TIP: Instead of using 31 for the last day of the month, use -1.
   */
  by_month_day?: number[];
}

/** How the payment schedule should repeat. */
export enum ScheduleRFC2445Frequency {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}

/**
 * Represents the days of the week within the month or year interval.
 * If any of the Days include a number then it indicates which occurrence
 * within the interval it applies to. No number means all Days of the period.
 * Ex. 1MO = First Monday. -2WE = Second last Wednesday. 0FR = All Fridays.
 */
export enum ScheduleRFC2445Day {
  SU = "SU",
  MO = "MO",
  TU = "TU",
  WE = "WE",
  TH = "TH",
  FR = "FR",
  SA = "SA",
}

export interface ScheduleRFC2445ByDay {
  num?: number;
  day?: ScheduleRFC2445Day;
}

export interface PaymentScheduleEvent {
  /** The token to represent this scheduled payment. */
  token?: string;
  /** The state of this scheduled payment. */
  state?: PaymentScheduleState;
  /** The initiator of this scheduled payment. */
  initiator_customer_token?: string;
  /** The getters of this scheduled payment. */
  getter_customer_tokens?: string[];
  /** The type of scheduled payment (ie. payment or bill). */
  orientation?: Orientation;
  /** The amount of this scheduled payment. */
  amount?: Money;
  /** The reason for this scheduled payment. */
  note?: string;
  /** The schedule for the payment. */
  schedule?: ScheduleRFC2445;
  /** When the next payment will be sent in Epoch milliseconds. */
  next_payment_at?: number;
}
